import React from 'react'

import {
  FinanceGetDimensionDocument,
  FinanceGetDimensionQuery,
  FinanceGetDimensionValuesDocument,
  FinanceGetDimensionValuesQuery,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export type DimensionValue =
  FinanceGetDimensionValuesQuery['finance']['customDimensionValues'][number]
export type Dimension = FinanceGetDimensionQuery['finance']['customDimensions'][number]

const useDimensionDetail = (id?: string) => {
  const { company } = useCurrentSession()

  const getDimensionQuery = useQuery(FinanceGetDimensionDocument, {
    variables: {
      id: Number(id),
      companyId: company.id,
    },
    skip: !id,
  })

  const dimensionLoading = !getDimensionQuery.data && !getDimensionQuery.error

  const getDimensionValuesQuery = useQuery(FinanceGetDimensionValuesDocument, {
    variables: {
      dimensionId: Number(id),
      tenant: { companyId: company.id },
    },
  })

  const valuesLoading = !getDimensionValuesQuery.data && !getDimensionValuesQuery.error

  const [showNewValueModal, setShowNewValueModal] = React.useState(false)

  const [valueToDelete, setValueToDelete] = React.useState<number | undefined>()
  const [valueToEdit, setValueToEdit] = React.useState<number | undefined>()

  return {
    loading: dimensionLoading || valuesLoading,
    dimension: getDimensionQuery.data?.finance.customDimensions[0],
    dimensionValues: getDimensionValuesQuery.data?.finance.customDimensionValues,
    refetchDimensionValues: getDimensionValuesQuery.refetch,
    showNewValueModal,
    setShowNewValueModal,
    valueToDelete,
    setValueToDelete,
    valueToEdit,
    setValueToEdit,
  }
}

export default useDimensionDetail
